module.exports = __webpack_public_path__ + "img/vr_set.4d1a346e.jpg";